// components/templates/sections/ChefSection.tsx
'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useDesign } from '@/context/DesignContext';

interface ChefSectionProps {
  images?: string[];
  subtitle: string;
  title: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
  design?: any;
}

export default function ChefSection({
  images = [],
  subtitle,
  title,
  description,
  buttonText = 'view all chef',
  buttonLink = '#',
  design: propDesign,
}: ChefSectionProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const imagesArray = Array.isArray(images) ? images : [];
  const headingFont = design?.typography?.headingFont || "'Sora', sans-serif";
  const bodyFont = design?.typography?.bodyFont || "'Plus Jakarta Sans', sans-serif";
  const primaryColor = design?.colors?.primary || '#E07A5F';
  const textColor = design?.colors?.text || '#1E1E1E';
  const borderRadius = design?.effects?.borderRadius || '8px';
  const btnStyle = design?.buttons?.outline || {
    class: 'tf-button style3',
    backgroundColor: 'transparent',
    borderColor: 'var(--primary)',
    textColor: 'var(--primary)',
    borderRadius: '30px',
    padding: '10px 25px',
  };
  const containerMaxWidth = design?.spacing?.containerMaxWidth || '1200px';

  const subtitleStyle: React.CSSProperties = {
    fontFamily: headingFont,
    color: primaryColor,
    marginBottom: '0.5rem',
  };
  const titleStyle: React.CSSProperties = {
    fontFamily: headingFont,
    fontSize: '2rem',
    fontWeight: design?.typography?.headingWeights?.h3 || 600,
    color: textColor,
    marginBottom: '1rem',
  };
  const descStyle: React.CSSProperties = {
    fontFamily: bodyFont,
    color: design?.colors?.textLight || '#6C757D',
    marginBottom: '1.5rem',
    lineHeight: 1.6,
  };
  const imageStyle: React.CSSProperties = {
    borderRadius: borderRadius,
    overflow: 'hidden',
    marginRight: '1rem',
    width: 'calc(50% - 0.5rem)',
  };
  const buttonStyle: React.CSSProperties = {
    backgroundColor: btnStyle.backgroundColor,
    border: btnStyle.borderColor ? `1px solid ${btnStyle.borderColor}` : 'none',
    color: btnStyle.textColor,
    padding: btnStyle.padding,
    borderRadius: btnStyle.borderRadius,
    cursor: 'pointer',
    display: 'inline-block',
    textDecoration: 'none',
  };

  if (imagesArray.length < 2) {
    return (
      <section className="chef-restaurant" style={{ padding: '60px 0' }}>
        <div className="container" style={{ maxWidth: containerMaxWidth, margin: '0 auto' }}>
          <p className="text-center">Images des chefs non disponibles.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="chef-restaurant" style={{ padding: '60px 0' }}>
      <div className="container" style={{ maxWidth: containerMaxWidth, margin: '0 auto' }}>
        <div className="row">
          <div className="col-xl-7 col-md-12">
            <div className="chef-restaurant-image">
              <div className="group-img" style={{ display: 'flex', gap: '1rem' }}>
                <div style={imageStyle}>
                  <Image src={imagesArray[0]} alt="" width={400} height={500} style={{ width: '100%', height: 'auto' }} />
                </div>
                <div style={imageStyle}>
                  <Image src={imagesArray[1]} alt="" width={400} height={500} style={{ width: '100%', height: 'auto' }} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-5 col-md-12">
            <div className="chef-restaurant-content">
              <div className="block-text">
                <p className="subtitle" style={subtitleStyle}>{subtitle}</p>
                <h3 className="title" style={titleStyle}>{title}</h3>
                <p className="text" style={descStyle}>{description}</p>
                <Link href={buttonLink} className={btnStyle.class} style={buttonStyle}>
                  {buttonText}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}